import { render, staticRenderFns } from "./WebFormBuilder.vue?vue&type=template&id=5915bda8&"
import script from "./WebFormBuilder.vue?vue&type=script&lang=js&"
export * from "./WebFormBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports